import { CategoriaOfertasPage } from './../categoria-ofertas/categoria-ofertas';
import { FiestasPage } from './../fiestas/fiestas';
import { LugaresInteresPage } from './../lugares-interes/lugares-interes';
import { TelefonosPage } from './../telefonos/telefonos';
import { CategoriaNoticiasPage } from './../categoria-noticias/categoria-noticias';
import { Pueblo } from './../../models/pueblo.model';
import { Component } from '@angular/core';
import { NavController, NavParams, App, LoadingController } from 'ionic-angular';
import { VariablesGlobales } from '../../providers/variables-globales';
import { BuscadorPage } from '../buscador/buscador';
import { BarriosPage } from '../lista-barrios/lista-barrios';
import { Consultas } from '../../providers/consultas';
import { BarrioModel } from '../../models/barrio.model';

/**
 * Generated class for the puebloMenuPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-pueblo-menu',
  templateUrl: 'pueblo-menu.html',
})
export class PuebloMenuPage {
  public pueblo:Pueblo;
  public loader: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global:VariablesGlobales,private app: App) {
      this.pueblo = this.navParams.data as Pueblo;
  }

  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad puebloMenuPage');
  }
  goToNoticias(){
    this.app.getRootNav().push(CategoriaNoticiasPage,{idCiudad: this.pueblo.id_ciudad,nombrePueblo: this.pueblo.nombre});
  }
  goToTelefonos(){
    this.app.getRootNav().push(TelefonosPage,{telefonos: this.pueblo.telefonos,nombrePueblo: this.pueblo.nombre});
  }
  goToMapa(){
    window.open(this.pueblo.mapa);
  }
  goToLugaresInteres(){
    this.app.getRootNav().push(LugaresInteresPage,{idCiudad: this.pueblo.id_ciudad,nombrePueblo: this.pueblo.nombre});
  }
  goToFiestas(){
    this.app.getRootNav().push(FiestasPage,{idCiudad: this.pueblo.id_ciudad,nombrePueblo: this.pueblo.nombre});
  }
  goToOfertas(){
    this.app.getRootNav().push(CategoriaOfertasPage,{idCiudad: this.pueblo.id_ciudad,nombrePueblo: this.pueblo.nombre});
  }

}



// WEBPACK FOOTER //
// ./src/pages/pueblo-menu/pueblo-menu.ts